// extracted by mini-css-extract-plugin
export default {"Cookie":"cookies_Cookie__TYM7V","CookieText":"cookies_CookieText__QmTmN"};